import React from 'react';

import { EXPLORE_ROUTE } from 'src/react/recommendations/Layout';

// State
import {
  completeTask,
  deleteTask,
  selectUncompletedTasks
} from 'src/react/recommendations/store/slices/tasks';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentView } from 'src/react/recommendations/store/slices/view';

// Components
import EmptyTaskList from 'src/react/recommendations/components/EmptyTaskList/EmptyTaskList';
import Task from 'src/react/recommendations/components/Task/Task';
import CompletedTasks from 'src/react/recommendations/CompletedTasks';
import { setModalOpen } from 'src/react/recommendations/store/slices/modal';
import logger from 'src/analytics/logger';
import { refreshIdeas } from 'src/react/recommendations/store/slices/ideas';
import {
  MARK_TASK_COMPLETE_MODAL,
  TASK_DETAILS_MODAL
} from './RecommendationModalView';

const TaskList = () => {
  const uncompletedTasks = useSelector(selectUncompletedTasks);
  const dispatch = useDispatch();
  const isEmpty = uncompletedTasks.length < 1;

  const navigateToExplore = () => {
    logger.trackElementClicked({
      elementId: 'Explore Recommendations',
      label: 'Explore'
    });
    dispatch(setCurrentView(EXPLORE_ROUTE));
  };

  const deleteCurrentTask = async (task) => {
    logger.trackElementClicked({
      elementId: 'Remove Recommendation From My List',
      label: 'Delete',
      recommendation_id: `RPLUS_${task.recommendation_id}`
    });

    await dispatch(deleteTask(task));
    await dispatch(refreshIdeas());
  };

  const markAsComplete = async (task) => {
    logger.trackElementClicked({
      elementId: 'Mark Task Complete',
      label: 'Mark as Complete',
      recommendation_id: `RPLUS_${task.recommendation_id}`
    });

    await dispatch(completeTask(task));
    dispatch(
      setModalOpen({
        isOpen: true,
        activeModal: MARK_TASK_COMPLETE_MODAL,
        recommendationId: task.recommendation_id
      })
    );
  };

  const showDetails = (task) => {
    logger.trackElementClicked({
      elementId: 'Task Learn More',
      label: 'Learn More',
      recommendation_id: `RPLUS_${task.recommendation_id}`
    });

    dispatch(
      setModalOpen({
        isOpen: true,
        activeModal: TASK_DETAILS_MODAL,
        recommendationId: task.recommendation_id
      })
    );
  };

  return (
    <div
      data-testid="tasklist_page"
      className="w-full flex flex-col justify-between"
    >
      {isEmpty ? (
        <EmptyTaskList onConfirm={navigateToExplore} />
      ) : (
        uncompletedTasks.map((task, index) => (
          <Task
            key={`${task.idea_external_id}_${index}`}
            task={task}
            completeAction={markAsComplete}
            deleteAction={deleteCurrentTask}
            learnMoreAction={showDetails}
          />
        ))
      )}
      <CompletedTasks />
    </div>
  );
};
TaskList.propTypes = {};

export default TaskList;
